import { createI18n } from "vue-i18n";
import nl from "locales/nl.json";

export const SUPPORTED_LOCALES = ["nl"] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = "nl";

/**
 * Resolve the active locale from the browser language, constrained to the
 * locales we support. Mirrors the backend `SetLocale` middleware, which
 * derives the locale from the `Accept-Language` header.
 */
export function resolveLocale(language?: string): SupportedLocale {
  const detectedLanguage =
    language ??
    (typeof navigator !== "undefined" ? navigator.language : DEFAULT_LOCALE);
  const base = detectedLanguage.split("-")[0];

  return (SUPPORTED_LOCALES as readonly string[]).includes(base)
    ? (base as SupportedLocale)
    : DEFAULT_LOCALE;
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: resolveLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: { nl },
});

export default i18n;
